"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _dragm = _interopRequireDefault(require("dragm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraggableTitle = /*#__PURE__*/function (_React$Component) {
  _inherits(DraggableTitle, _React$Component);

  var _super = _createSuper(DraggableTitle);

  function DraggableTitle() {
    var _this;

    _classCallCheck(this, DraggableTitle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "updateTransform", function (transformStr) {
      //require trnsformation logic to restrict modal to drag out of window
      var orignalTransform = transformStr;
      var slicedTransformString = orignalTransform.substring("10").slice(0, -1).split(",");
      var xPx = slicedTransformString[0].replace("px", "");
      var yPx = slicedTransformString[1].replace("px", "");

      if (xPx < -300) {
        xPx = -300;
      }

      if (xPx > 300) {
        xPx = 300;
      }

      if (yPx < -22) {
        yPx = -22;
      }

      if (yPx > 530) {
        yPx = 530;
      }

      var result = "translate(";
      result = result.concat(xPx, "px,", yPx, "px)");
      _this.modalDom.style.transform = result;
    });

    return _this;
  }

  _createClass(DraggableTitle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document.getElementsByClassName("ant-modal-wrap")) {
        var antModalWrap = document.getElementsByClassName("ant-modal-wrap");
        var modalLength = antModalWrap.length - 1;
        var modalDom = antModalWrap[modalLength];
        this.modalDom = modalDom;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var title = this.props.title;
      return /*#__PURE__*/_react.default.createElement(_dragm.default, {
        updateTransform: this.updateTransform
      }, /*#__PURE__*/_react.default.createElement("div", null, title));
    }
  }]);

  return DraggableTitle;
}(_react.default.Component);

var _default = DraggableTitle;
exports.default = _default;